<template>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button :icon="arrowBackCircleOutline" color="primary" fill="clear" @click="click">
                <ion-icon :icon="arrowBackCircleOutline" />

                {{ unSlug(backText) }}
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { IonButton, IonButtons, IonToolbar, IonIcon } from '@ionic/vue';
import { arrowBackCircleOutline } from 'ionicons/icons';
import { unSlug, nullOrEmpty } from '@/services/stringService';

export default defineComponent({
    props: { backText: String, func: Function },
    components: { IonButton, IonButtons, IonToolbar, IonIcon },
    data() {
        return {
            arrowBackCircleOutline,
        };
    },
    methods: {
        unSlug,
        click() {
            if (this.func) {
                this.func();
            } else {
                const arr = this.$route.path.split('/');
                const removedLevel = arr.splice(0, arr.length - 1).join('/');
                this.$emit('back');
                this.$route.path.includes('bonus')
                    ? /**
                       * Cheetah challenges fire off a "HashChangeEvent" that messes with the vue router.
                       * Ideally, the hash event is removed but I could not find documentation https://docs.cheetahces.com/en-us/loyalty/developer/sdk/js_sdk/07_override_ui_templates.html#override-default-templates-using-stellartmpl-namespace
                       */
                      (window.location.href = '/rewards')
                    : nullOrEmpty(removedLevel)
                    ? this.$router.push(removedLevel)
                    : this.$router.back();
            }
        },
    },
});
</script>

<style scoped>
ion-back-button {
    --icon-margin-end: 4px;
}
ion-toolbar {
    --background: transparent;
}
</style>
